import cn from "classnames"
import { Formik } from "formik"
import React, { Component } from 'react'
import PageContents from '../components/pageContents'
import SEO from "../components/seo"
import NewLayout from '../layout/newLayout'
import { sendContact } from "../services/contact"
import styles from '../styles/scss/pages/industrialSampleRequestForm.module.scss'
import {
	TextInput,
	Select,
	ErrorSummary,
	FormStatus,
	SubmitButton,
	RequiredNote,
	bind,
	summaryErrors,
	phoneError,
	zipError,
	isValidEmail,
	formStyles as f,
} from '../components/form'

export default class Index extends Component {

	constructor(props) {
		super(props);
		this.state = {
			submitError: false,
			submitted: false,
			selectedIndustry: null,
			selectedNumberOfEmployees: null,
		  	isMobile: false,
		};
		this.handleResize = this.handleResize.bind(this);
	}

	componentDidMount() {
		window.addEventListener('resize', this.handleResize);
		// Initial check to set the correct value of isMobile
		this.handleResize();
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.handleResize);
	}

	handleResize() {
		if (window.innerWidth <= 576) {
			this.setState({ isMobile: true });
		} else {
			this.setState({ isMobile: false });
		}
	}
	
	industries = [{
		value: 'food-beverage',
		text: 'Food & Beverage'
	}, {
		value: 'oil-gas-chemical',
		text: 'Oil / Gas / Chemical'
	}, {
		value: 'mining-aggregate',
		text: 'Mining / Aggregate'
	}, {
		value: 'forest-paper',
		text: 'Forest / Paper'
	}, {
		value: 'power-utilities',
		text: 'Power & Utilities'
	}, {
		value: 'pharmaceutical',
		text: 'Pharmaceutical'
	}, {
		value: 'government',
		text: 'Government'
	}, {
		value: 'transportation-vehicles',
		text: 'Transportation / Vehicles'
	}, {
		value: 'warehouse-logistics',
		text: 'Warehouse & Logistics'
	}, {
		value: 'metal-metal-fabrication',
		text: 'Metal / Metal Fabrication'
	}, {
		value: 'commercial-construction',
		text: 'Commercial/Construction'
	}, {
		value: 'other',
		text: 'OTHER'
	}]

	numberOfEmployees = [{
		value: '1 to 9',
		text: '1 to 9'
	}, {
		value: '10 to 49',
		text: '10 to 49'
	}, {
		value: '50 to 99',
		text: '50 to 99'
	}, {
		value: '100 to 499',
		text: '100 to 499'
	}, {
		value: 'Over 500',
		text: '500+'
	}]

	render() {
		const pg = this.props.pageContext.page
		const attached = pg.attachments.filter((att) => {
			return att.slug === 'thank-you-contact'
		})
		var thankyou = null
		if (attached.length > 0) {
			thankyou = attached[0]
		} else {
			throw new Error("thank-you-contact is not attached")
		}
		const heroSectionContent = {
			title: pg.content[0].title,
			image: pg.content[0].image,
		}

		return (
			<NewLayout>
				{pg.seo.title && <h1 style={{ display: 'none' }}>{pg.seo.title}</h1>}
				<SEO page={pg} />
				<div className='d-flex flex-column flex-fill'>
					<div
						className={styles.hero}
						style={{
							backgroundImage: `url(${
								this.state.isMobile
									? "/img/industrial-page/industrial-sample-request-form-hero-mobile.png"
									: heroSectionContent.image.url
							})`,
						}}
					>
						<h2 className={styles.heroTitle}>
							{heroSectionContent.title}
						</h2>
					</div>
					<div className={styles.container}>
						<>
							<div className={cn(styles.formItems, "row")}>
								<div className={styles.formContainer}>
									{
										this.state.submitted ?
										<PageContents content={thankyou.content} />
										:
										<>
											<h3 className={styles.infoTitle}>
												personal information
											</h3>
											<Formik
												initialValues={{
													first_name: "",
													last_name: "",
													job_title: "",
													company: "",
													business_phone: "",
													business_email: "",
													business_address: "",
													zip_code: "",
													industry: "",
													num_employees: "",
													message: "",
													preferred_distributors: ""
												}}
												validate={values => {
													var errors = []
													if (values.first_name === "") {
														errors.push({ field: "first_name", message: "First Name is required" })
													}
													if (values.last_name === "") {
														errors.push({ field: "last_name", message: "Last Name is required" })
													}
													if (values.job_title === "") {
														errors.push({ field: "job_title", message: "Job Title is required" })
													}
													if (values.company === "") {
														errors.push({ field: "company", message: "Company is required" })
													}
													const phoneMsg = phoneError(values.business_phone, { required: true, requiredMessage: "Business Phone Number is required", label: "Business phone number" })
													if (phoneMsg) errors.push({ field: "business_phone", message: phoneMsg })
													if (values.business_email === "") {
														errors.push({ field: "business_email", message: "Business Email is required" })
													} else if (!isValidEmail(values.business_email)) {
														errors.push({ field: "business_email", message: "Invalid email address" })
													}
													if (values.business_address === "") {
														errors.push({ field: "business_address", message: "Business Address is required" })
													}
													const zipMsg = zipError(values.zip_code, { required: true })
													if (zipMsg) errors.push({ field: "zip_code", message: zipMsg })
													if (values.industry === "") {
														errors.push({ field: "industry", message: "Please select an Industry" })
													}
													if (values.num_employees === "") {
														errors.push({ field: "num_employees", message: "Please select a Number of Employees" })
													}
													if (values.preferred_distributors === "") {
														errors.push({ field: "preferred_distributors", message: "Please enter Preferred distributors" })
													}
													return errors
												}}
												onSubmit={(values, { setSubmitting }) => {
													this.setState({ submitError: false })
													sendContact(values, 'sample-request').then(() => {
														setSubmitting(false)
														this.setState({ submitted: true })
													}).catch((err) => {
														console.log('ERROR!')
														console.log(err)
														setSubmitting(false)
														this.setState({ submitError: true })
													})
												}}
											>
												{(props) => (
													<form className={f.form} onSubmit={props.handleSubmit} noValidate>
														<RequiredNote />
														<ErrorSummary errors={summaryErrors(props)} submitCount={props.submitCount} />
														<FormStatus status={this.state.submitError ? "error" : null} />
														<div className={f.row}>
															<TextInput label="First Name" required autoComplete="given-name" {...bind(props, "first_name")} />
															<TextInput label="Last Name" required autoComplete="family-name" {...bind(props, "last_name")} />
														</div>
														<div className={f.row}>
															<TextInput label="Job Title" required autoComplete="organization-title" {...bind(props, "job_title")} />
															<TextInput label="Company" required autoComplete="organization" {...bind(props, "company")} />
														</div>
														<div className={f.row}>
															<TextInput label="Business Phone" type="tel" mask="phone" required autoComplete="tel-national" {...bind(props, "business_phone")} />
															<TextInput label="Business Email" type="email" required autoComplete="email" {...bind(props, "business_email")} />
														</div>
														<div className={f.row}>
															<TextInput label="Business Address" required autoComplete="street-address" {...bind(props, "business_address")} />
															<TextInput label="Zip Code" required autoComplete="postal-code" {...bind(props, "zip_code")} />
														</div>
														<div className={f.row}>
															<Select label="Industry" required placeholder="Select An Industry" options={this.industries} {...bind(props, "industry")} />
															<Select label="# of employees who require WD-40" required placeholder="Select Number Of Employees" options={this.numberOfEmployees} {...bind(props, "num_employees")} />
														</div>
														<TextInput label="Who are your preferred distributors?" required {...bind(props, "preferred_distributors")} />
														<div className={f.actions}>
															<SubmitButton busy={props.isSubmitting}>Submit</SubmitButton>
														</div>
													</form>
												)}
											</Formik>
										</>
									}
								</div>
							</div>
						</>
					</div>
				</div>
			</NewLayout>
		);
	}
}